import { BrowserRouter, Link, Route, Routes } from 'react-router-dom';
import './App.css';
import MainShow from './components/main/MainShow';
import HomeShow from './components/home/HomeShow';
import ProductsShow from './components/products/ProductsShow';
import ProductShow from './components/products/ProductShow';


function App() {
  return (
    <>
      <div className="App">
        <BrowserRouter>
          <nav className="navbar bg-primary" data-bs-theme="dark">
            <div className="container-fluid">
              <Link className="navbar-brand" to="/">RONLINEX PERFUMERÍA</Link>
              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarScroll" aria-controls="navbarScroll" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="navbarScroll">
                <ul className="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll" style={{ "--bs-scroll-height": "100px" }}>
                  <li className="nav-item">
                    <Link className="nav-link active" aria-current="page" to="/">Inicio</Link>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
          <Routes>
            <Route path="/" element={<HomeShow />} />
            <Route path="/MainShow" element={<MainShow />} />
            <Route path='/Product/:ProductId' element={<ProductShow />} />
            <Route path="/ProductsBycategory/:Category" element={<ProductsShow />} />
          </Routes>
        </BrowserRouter>
      </div>
    </>
  );
}

export default App;
